import PropTypes from "prop-types"

export const BACKGROUND_RECT = PropTypes.shape({
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  style: PropTypes.object,
})

export const HIGHLIGHTER = PropTypes.shape({
  x1: PropTypes.number.isRequired,
  x2: PropTypes.number.isRequired,
  y1: PropTypes.number.isRequired,
  y2: PropTypes.number.isRequired,
})

export const MARK = PropTypes.shape({
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  style: PropTypes.object,
})

export const LINE = PropTypes.shape({
  d: PropTypes.string,
  transform: PropTypes.string,
  style: PropTypes.object.isRequired,
})
